import React from 'react';
import { Icon } from '@ohif/ui';

interface AISuggestionBoxProps {
    visible: boolean;
    suggestions: string[];
}

const AISuggestionBox: React.FC<AISuggestionBoxProps> = ({ visible, suggestions }) => {
    if (!visible) return null;

    return (
        <div
            className="w-80 min-w-[320px] max-w-xs rounded-xl p-5 animate-fade-in border border-[var(--v2-border-card)] bg-[var(--v2-bg-card)] shadow-[var(--v2-shadow-card)]"
        >
            <h3 className="text-lg font-bold mb-3 flex items-center gap-2 text-[var(--v2-primary-500)]">
                <Icon name="sparkles-Icon" className="w-5 h-5 text-[var(--v2-primary-500)]" />
                AI Suggestions
            </h3>
            <ul className="list-disc list-inside space-y-2.5 text-[15px] leading-relaxed text-[var(--v2-text-secondary)]">
                {suggestions.map((suggestion, idx) => (
                    <li key={idx}>{suggestion}</li>
                ))}
            </ul>
        </div>
    );
};

export default AISuggestionBox;
